<ng-container *ngIf="!!get">
    <tt-divider class="flex-1" ttRememberId="w_projectfolders.divider">
        <tt-divider-columns>
            <tt-divider-pane ttSize="20">
                <tt-card ttClass="flex-1 height-full">
                    <!-- <tt-input ttLabel="item_id_selected" [ttModel]="get.item_id_selected" ttReadonly></tt-input>
                    <tt-input ttLabel="item_name_selected" [ttModel]="get.item_name_selected" ttReadonly></tt-input>
                    <tt-input ttLabel="item_type_selected" [ttModel]="get.item_type_selected" ttReadonly></tt-input> -->
                    <tt-tree-view
                        *ngIf="folders.length > 0"
                        [ttRememberIdExpanded]="'w_projectfolders.expanded.' + this.get.project_keyno"
                        ttDraggable
                        [(ttSelectedId)]="get.item_id_selected"
                        (ttOnSelect)="onFolderSelected($event)"
                        [(ttData)]="folders"
                        (ttDrop)="onListUpdated()"
                    ></tt-tree-view>
                </tt-card>
            </tt-divider-pane>
            <tt-divider-pane ttSize="80">
                <tt-project-folder [params]="get" (folderChange)="loadFolders()" (onDelete)="selectNextTreeItem()"></tt-project-folder>
            </tt-divider-pane>
        </tt-divider-columns>
    </tt-divider>
    <tt-card *ngIf="get.show_setting === '1'" class="col-xs-12 p-5">
        <tt-button-settings ttWebpage="projectfolders"></tt-button-settings>
    </tt-card>
</ng-container>
